// Every chat view historically assumed exactly two participants and derived a flat
// {name, role, avatar, city} from "the other user" (users.find(u => u._id !== me)). That
// logic was duplicated across ChatStore. This is the single place it now lives.
//
// For a plain 1:1 conversation (<=2 active participants) the returned shape is identical to
// the old inline logic, so existing CS/host chats are unaffected. For a booking conversation
// with a referral host added, it also attaches `participants` (role-labelled, active members
// only) for the multi-party chat UI to render.
export const ROLE_LABELS = {
  guest: "Guest",
  booking_host: "Booking Host",
  referral_host: "Referral Host",
}

export function normalizeConversation(conversation, userId) {
  const roles = conversation.participant_roles || {}
  const isActive = (id) => {
    const entry = roles[id]
    return !entry || !entry.removed_at
  }
  const activeUsers = (conversation.users || []).filter((u) => isActive(u._id))
  const others = activeUsers.filter((u) => u._id !== userId)

  if (others.length <= 1) {
    const user = others[0]
    return {
      ...conversation,
      key: conversation._id,
      name: user?.name || "",
      role: user?.role || "user",
      avatar: user?.avatar,
      city: user?.city,
    }
  }

  const participants = activeUsers.map((u) => ({
    user: u,
    role: roles[u._id]?.role || (u._id === userId ? "guest" : "user"),
  }))
  const bookingHost = participants.find((p) => p.role === "booking_host")

  return {
    ...conversation,
    key: conversation._id,
    name: bookingHost ? `${bookingHost.user.name}'s booking` : conversation.name || "Booking chat",
    role: "booking",
    avatar: bookingHost?.user?.avatar,
    city: bookingHost?.user?.city,
    participants,
  }
}
